import queryString from 'query-string'

export function loginPath(redirectTo?: string) {
  return `/login${redirectTo ? redirectToQuery(redirectTo) : ''}`
}

function redirectToQuery(redirectTo: string) {
  return `?${queryString.stringify({ redirect_to: redirectTo })}`
}
